import React, { useEffect, useState } from 'react';
import Loader from './loader';
import styled from 'styled-components';

const H2Styled = styled.h2`
  position: relative;
  text-align: center;
  margin: 32px auto 16px;
  font-size: 18px;
  font-weight: 500;
  opacity: 0.9;
  
  span {
    display: inline-block;
    background: linear-gradient(135deg, #00BCD4, #00E5FF);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-weight: 700;
    font-size: 24px;
    margin-left: 8px;
  }
`;

const TotalServersCount = () => {
    const [loader, setLoader] = useState(true);
    const [serversCount, setServersCount] = useState(0);

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const run = async () => {
            try {
                const res = await fetch('https://api.syagent.com/servers-count', {
                    method: 'GET',
                    signal: controller.signal,
                    // Optional: include credentials/headers here if needed
                });
                if (!res.ok) throw new Error(`HTTP ${res.status}`);
                const data = await res.json();

                if (!isMounted) return;
                const count = data?.data?.data_o?.servers;
                if (typeof count === 'number') {
                    setServersCount(count);
                }
            } catch (err) {
                console.error('Failed to load servers count', err);
            } finally {
                if (isMounted) setLoader(false);
            }
        };

        run();

        return () => {
            isMounted = false;
            controller.abort();
        };
    }, []);

    return (
        <H2Styled>
            Total servers monitored : <span>{ loader
            ? <Loader/>
            : serversCount }</span>
        </H2Styled>
    );
};

export default TotalServersCount;
